/**
 * Trazabilidad del cliente axios: cada petición lleva X-Request-ID propio,
 * X-Client, X-Platform y X-Device-Id (el backend los agrega a sus logs), y las
 * fallas del servidor o de conexión se reportan una sola vez.
 */
function newRequestId() {
    const cryptoApi = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
    if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

function setHeader(headers, name, value) {
    if (typeof headers.set === 'function') headers.set(name, value);
    else headers[name] = value;
}

export function attachTracing(instance, { client, platform, deviceId = () => null, timeoutMs } = {}) {
    if (timeoutMs) instance.defaults.timeout = timeoutMs;

    instance.interceptors.request.use((config) => {
        const id = deviceId();
        setHeader(config.headers, 'X-Request-ID', newRequestId());
        if (client) setHeader(config.headers, 'X-Client', client);
        if (platform) setHeader(config.headers, 'X-Platform', platform);
        if (id) setHeader(config.headers, 'X-Device-Id', id);
        return config;
    });
}

const REPORT_PATH = /(^|\/)client-errors$/;

/** `report(operation, error)`: solo fallas de conexión y del servidor; los 4xx son esperables. */
export function attachErrorReporting(instance, report) {
    instance.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            const isReport = REPORT_PATH.test(String(error?.config?.url ?? '').split('?')[0]);
            const failed = error?.isAxiosError && error.code !== 'ERR_CANCELED'
                && (status === undefined || status >= 500);
            if (failed && !isReport) {
                try { report('web.api', error); } catch { /* Reportar es opcional. */ }
            }
            return Promise.reject(error);
        },
    );
}
